import React from 'react';
export function Footer() {
  return <footer className="bg-navy py-12 px-5 md:px-10 w-full" data-id="element-65">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-66">
        <div className="text-2xl tracking-tight" data-id="element-67">
          <span className="text-white font-bold font-heading" data-id="element-68">Clean</span>
          <span className="text-accent-teal font-bold font-heading" data-id="element-69">AI</span>
        </div>

        <div className="text-white/50 text-sm font-body" data-id="element-70">
          &copy; 2026 CleanAI. Tutti i diritti riservati.
        </div>
      </div>
    </footer>;
}